import { render } from "./ViewTopNav.vue?vue&type=template&id=2cdcdbc0"
import script from "./ViewTopNav.vue?vue&type=script&lang=js"
export * from "./ViewTopNav.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ranjanbajracharya/Documents/upwork/kaz/hbhotel-pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__